// extracted by mini-css-extract-plugin
export var followUs = "FollowUs-module--follow-us--a153c";
export var socialList = "FollowUs-module--social-list--84bfa";